import React, { useState, useEffect, useRef } from 'react';


export default function FAQ() {
   const [openFaqs, setOpenFaqs] = useState(new Set());

  const toggleFaq = (column, index) => {
    const key = `${column}-${index}`;
    setOpenFaqs(prev => {
      const newSet = new Set(prev);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      return newSet;
    });
  };

     const cardRefs = useRef([]);
      const headlineRef = useRef(null);
      const descriptionRef = useRef(null);
    
      
      useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-show");
            }
          });
        },
        { threshold: 0.3 }
      );
    
      // Observe loan cards
      cardRefs.current.forEach((el) => {
        if (el) observer.observe(el);
      });
    
      // Observe headline
      if (headlineRef.current) observer.observe(headlineRef.current);
       if (descriptionRef.current) observer.observe(descriptionRef.current);
    
      return () => observer.disconnect();
    }, []);
  
    

  const leftFaqs = [
    { 
      q: "Why should I take a loan from Reap Capital?", 
      a: "Reap Capital offers fast approvals, transparent pricing, and flexible loan options tailored specifically for MSMEs. We understand your business needs and provide personalized support throughout the process." 
    },
    { 
      q: "What can I use the loan for?", 
      a: "You can use the loan for working capital, business expansion, buying inventory, clearing vendor payments, or any other business-related need." 
    },
    { 
      q: "Who can apply for a loan?", 
      a: "Any registered business owner, sole proprietor, partnership, or private limited company operating in India for at least 1 year can apply. Minimum annual turnover requirements may apply." 
    },
    { 
      q: "What documents do I need to apply for?", 
      a: "Basic documents include: Business registration proof, GST returns (last 6 months), bank statements (last 6 months), KYC documents (Aadhaar, PAN), and recent financial statements." 
    },
    { 
      q: "How fast can i get the money", 
      a: "Once your application is complete and verified, the loan can be approved and disbursed within a few working days." 
    },
  ];

  const rightFaqs = [
    { 
      q: "Are there any extra charges apart from the interest?", 
      a: "All charges are disclosed upfront including processing fees and applicable GST. There are no hidden charges or unofficial fees. What you see in your loan agreement is what you pay." 
    },
    { 
      q: "How do I send my documents?", 
      a: "You can upload documents directly through our secure online portal. Alternatively, you can email them or share via WhatsApp with your dedicated relationship manager." 
    },
    { 
      q: "What's the loan amount and repayment period?", 
      a: "Loan amounts range from ₹1 lakh to ₹1 crore. Repayment tenure varies from 3 months to 36 months depending on the loan type and your business profile." 
    },
    ,
    { 
      q: "What's the loan amount and repayment period?", 
      a: "Loan amounts range from ₹1 lakh to ₹1 crore. Repayment tenure varies from 3 months to 36 months depending on the loan type and your business profile." 
    }
    ,
    { 
      q: "What's the loan amount and repayment period?", 
      a: "Loan amounts range from ₹1 lakh to ₹1 crore. Repayment tenure varies from 3 months to 36 months depending on the loan type and your business profile." 
    }
   
  ];

  const renderFAQ = (faq, index, column) => {
    const key = `${column}-${index}`;
    const isOpen = openFaqs.has(key);

    return (
       <div
      onClick={() => toggleFaq(column, index)}

  key={index}
  className="h-fit bg-white rounded-3xl border border-[1px] border-gray-200 overflow-hidden hover:border-[#0BA36C] transition-all duration-500 ease-in-out transform  active:animate-click
"
>
  <div className="border-[6px] border-[#0000000D] rounded-3xl shadow-xl hover:shadow-2xl transition-shadow duration-500">
    
    {/* Button */}
    <button
      className="
        w-full px-[24px] py-[12px]
        md:px-[20px] md:py-[10px]
        lg:px-[20px] lg:py-[16px]
        flex items-center justify-between text-left
        transition-all duration-300
      "
    >
      <span className="font-normal font-inter text-black pr-4 text-[16px]">
        {faq.q}
      </span>

      {/* Icon */}
     <div className="relative w-[20px] h-[20px] flex items-center justify-center">
  
  {/* Horizontal Bar (always visible) */}
  <span className="absolute w-6 h-[4px] bg-[#0BA36C]  transition-all duration-300" />

  {/* Vertical Bar (rotates 90° when open) */}
  <span
    className={`
      absolute h-6 w-[4px] bg-[#0BA36C]
      transition-all duration-300 origin-center
      ${isOpen ? "rotate-90" : "rotate-0"}
    `}
  />
</div>

    </button>

    {/* Dropdown */}
    <div
      className={`
        overflow-hidden transition-all duration-500 ease-in-out
        ${isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}
      `}
    >
      <div
        className={`
          px-8 pb-4 md:px-8 md:pb-6 text-gray-600 pt-4 leading-relaxed 
          transition-all duration-500
          ${isOpen ? "translate-y-0" : "-translate-y-4"}
        `}
      >
        {faq.a}
      </div>
    </div>
  </div>
</div>

    );
  };
  return (
    <>
    <style>{`.card-base {
            transition: opacity 0.3s ease-out;
          }
  
          .animate-show {
            animation: floatIn 1s ease-out both;
            opacity: 1;
          }
  
          @keyframes floatIn {
            0% {
              opacity: 0;
              transform: translateY(30px) scale(0.95);
            }
            100% {
              opacity: 1;
              transform: translateY(0px) scale(1);
            }
          }
  
          .word-animate {
            display: inline-block;
            opacity: 0;
            transform: translateY(20px);
          }
  
          .animate-show .word-animate {
            animation: wordReveal 0.4s ease-out forwards;
          }
         
  
          @keyframes wordReveal {
            0% {
              opacity: 0;
              transform: translateY(20px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
    <section id='faq' className="pt-[60px] md:pt-[60px] lg:pt-[18px] pb-[72px] md:pb-[72px] lg:pb-[72px]  justify-center ">
      <div className='max-w-[1280px] mx-auto px-4  sm:px-6 md:px-10 lg:px-12 '>
         <div className='  flex flex-col gap-[24px]  mx-auto -mb-4 sm:-mb-4 lg:-mb-4 max-w-[322px] sm:max-w-[402px] md:max-w-[810px] lg:max-w-[1280px]'>
         
                       <div className="flex justify-center  items-center  mb-2 sm:mb-6 md:mb-2 lg:mb-6">
                       <div ref={descriptionRef}
                    className=" headline-animate w-fit h-fit  border-[#0BA36C] border-[1.5px] rounded-tl-[21px] rounded-tr-[6px] rounded-bl-[5px] rounded-br-[6px] pt-[4px] pr-[16px] pl-[16px] pb-[5px] ">
                         <span className=" text-[#0BA36C] text-[16px] font-inter font-semibold">FAQ</span>
                       </div>
                     </div>
                        <h2
  ref={headlineRef}
                           className=" text-[28px] leading-[36px]  font-poppins  sm:text-[30px]  md:text-[38px] lg:text-[48px] sm:leading-[36px] md:leading-[50px] lg:leading-[62px] font-medium  -tracking-[4%] text-gray-900 text-center">
  {["Everything","You"].map((word, i) => (
    <span
      key={i}
      className="word-animate"
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  <br/>

  {["Need", "to", "Know"].map((word, i) => (
    <span
      key={i + 4}
      className="word-animate text-[#0BA36C]"
      style={{ animationDelay: `${(i + 4) * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

 
</h2>
                     
                          
                                   
                           
                   </div >

                 <div className="grid md:grid-cols-2 gap-6 pt-20 max-w-6xl mx-auto items-start">
        <div className='flex flex-col mx-auto gap-6 w-full'>
          {leftFaqs.map((faq, index) => renderFAQ(faq, index, 'left'))}
        </div>
        
        <div className='flex flex-col mx-auto gap-6 w-full'>
          {rightFaqs.map((faq, index) => renderFAQ(faq, index, 'right'))}
        </div>
      </div>

        </div>
      </section>
      </>
  );
}
